import { can } from './permissions.generated';
import type { ScoreSummary, VenueRole } from './types';

export interface DeleteScoreResult {
  scoreId: string;
  unassignedRooms: string[];
  nudgedDeviceIds: string[];
  versionsDeleted: number;
  objectsDeleted: number;
}

/**
 * Global score deletion is a cloud management action. A local-only console cannot authorize it, and a
 * venue member sees it only for a score they own; venue manager+ and staff mirror the platform's gate.
 */
export function canDeleteScore(role: VenueRole, signedIn: boolean, ownsScore: boolean): boolean {
  return signedIn && (ownsScore || can(role, 'scores.delete'));
}

/** Apply the command's returned identity to a score inventory, without guessing before it succeeds. */
export function scoresAfterDelete(scores: ScoreSummary[], result: DeleteScoreResult): ScoreSummary[] {
  return scores.filter((score) => score.scoreId !== result.scoreId);
}
